module.exports = __webpack_public_path__ + "static/hexomatic-vs-all-d16b350b784a3a935c588cdf6ac9dd44.png";